import React, { useState, useEffect } from "react";
import smartParkService from "../../../axios";
import { makeStyles, Paper, Grid, Typography } from "@material-ui/core";
import equipmentRoomImage from "../../../assets/img/equipmentroom1.png";
import OccupancyCard from "../../../components/OccupancyCard/OccupancyCard";
import SvgContainer from "./SvgContainer";
import steppers from "../../../assets/img/steppers.png";
import ellipticals from "../../../assets/img/ellipticals.png";
import rowers from "../../../assets/img/rowers.png";
import OccupancyCardRenderer from "../../../components/OccupancyCard/OccupancyCardRenderer";
import treadmillImage from "../../../assets/img/treadmill.png";
import treadmillBusy from "../../../assets/img/Treadmill-busy.png";
import treadmillEmpty from "../../../assets/img/Treadmill-empty.png";
import ellipticalsBusy from "../../../assets/img/Ellipticals-busy.png";
import ellipticalsEmpty from "../../../assets/img/Ellipticals-empty.png";
import MafcEquipmentPopularTimes from "../../Charts/MafcEquipmentPopularTimes";
import MafcEquipmentWeeklySummary from "../../Charts/MafcEquipmentWeeklySummary";

const MafcEquipmentRoom = ({
  defaultSize = "100%",
  startDate,
  endDate,
  lgScreen,
  xlscreen,
  xxlScreen,
}) => {
  const [fieldsList, setFieldsList] = useState([
    {
      name: "Treadmill",
      icon: treadmillImage,
      total: null,
      occupied: null,
    },
    {
      name: "Bikes",
      icon: steppers,
      total: null,
      occupied: null,
    },
    {
      name: "Elliptical",
      icon: ellipticals,
      total: null,
      occupied: null,
    },
    {
      name: "Rowers",
      icon: rowers,
      total: null,
      occupied: null,
    },
  ]);
  const [totalOccupiedTreadmill, setTotalOccupiedTreadmill] = useState(0);
  const [totalOccupiedEllipticals, setTotalOccupiedEllipticals] = useState(0);
  const [equipmentOptions, setEquipmentOptions] = useState([]);
  const useStyles = makeStyles((theme) => ({
    container: {
      marginBottom: 10,
    },
    paperContainer: {
      height: defaultSize,
      display: "flex",
      flexDirection: "column",
      "@media (max-width: 1279px)": {
        height: "100%",
      },
      "@media (min-width: 1280px) and (max-width:1439px)": {
        height: lgScreen || defaultSize,
      },
      "@media (min-width: 1440px) and (max-width:1749px)": {
        height: xlscreen || defaultSize,
      },
      "@media (min-width: 1750px) ": {
        height: xxlScreen || defaultSize,
      },
    },
    chartContainer: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    graphTitle: {
      paddingTop: 5,
      paddingLeft: 10,
    },
  }));
  const classes = useStyles();

  const fetchTreadmillData = async () => {
    await smartParkService
      .get("api/equipment/91474e36-76c5-4d59-a8da-2998ab14a4bf/equipmentList")
      .then((res) => {
        if (res?.data?.sensors?.length > 0) {
          res.data.sensors.forEach((sensor) => {
            if (sensor.location_zone.toLowerCase() === "treadmill") {
              setTotalOccupiedTreadmill(sensor.last_value);
            } else if (sensor.location_zone.toLowerCase() === "elliptical") {
              setTotalOccupiedEllipticals(sensor.last_value);
            }
            setFieldsList((prev) => {
              return prev.map((field) => {
                if (
                  field.name.toLowerCase() ===
                  sensor.location_zone.toLowerCase()
                ) {
                  return {
                    ...field,
                    total: sensor.total_count,
                    occupied: sensor.last_value,
                  };
                }
                return field;
              });
            });
          });
        }
      });
  };

  const fetchEquipmentOptions = async () => {
    const response = await smartParkService
      .get(
        "api/equipment/options?facility=91474e36-76c5-4d59-a8da-2998ab14a4bf"
      )
      .then((res) => {
        if (res.status === 200) {
          if (res.data?.options?.length > 0) {
            const option = res.data.options.map((option) => {
              return {
                name:
                  option.device_type.charAt(0).toUpperCase() +
                  option.device_type.slice(1),
                value: option.device_id,
              };
            });
            setEquipmentOptions(option);
          }
        }
      });
  };

  useEffect(() => {
    fetchTreadmillData();
    fetchEquipmentOptions();
  }, []);

  const equipmentRoomMap = [
    // {
    //   name: "Total Count",
    //   type: "rect",
    //   xAxis: 650,
    //   yAxis: 10,
    //   width: 495,
    //   height: 100,
    //   color: "#487fb3",
    //   radiusX: "10px",
    //   radiusY: "10px",
    //   stroke: "#a1a1a0",
    //   strokeWidth: "5",
    //   lineCap: "butt",
    // },
    // {
    //   name: "Current Occupancy",
    //   type: "text",
    //   xAxis: 680,
    //   yAxis: 70,
    //   body: `${totalOccupancy} `,
    //   fontSize: 30,
    //   textColor: "#fdfdfd",
    // },
    {
      name: "Treadmill 7",
      type: "image",
      width: 150,
      xAxis: 410,
      yAxis: 40,
      body: totalOccupiedTreadmill > 6 ? treadmillBusy : treadmillEmpty,
    },
    {
      name: "Treadmill 6",
      type: "image",
      width: 150,
      xAxis: 358,
      yAxis: 75,
      body: totalOccupiedTreadmill > 5 ? treadmillBusy : treadmillEmpty,
    },
    {
      name: "Treadmill 5",
      type: "image",
      width: 150,
      xAxis: 298,
      yAxis: 110,
      body: totalOccupiedTreadmill > 4 ? treadmillBusy : treadmillEmpty,
    },
    {
      name: "Treadmill 4",
      type: "image",
      width: 150,
      xAxis: 238,
      yAxis: 145,
      body: totalOccupiedTreadmill > 3 ? treadmillBusy : treadmillEmpty,
    },
    {
      name: "Treadmill 3",
      type: "image",
      width: 150,
      xAxis: 178,
      yAxis: 180,
      body: totalOccupiedTreadmill > 2 ? treadmillBusy : treadmillEmpty,
    },
    {
      name: "Treadmill 2",
      type: "image",
      width: 150,
      xAxis: 118,
      yAxis: 215,
      body: totalOccupiedTreadmill > 1 ? treadmillBusy : treadmillEmpty,
    },
    {
      name: "Treadmill 1",
      type: "image",
      width: 150,
      xAxis: 58,
      yAxis: 250,
      body: totalOccupiedTreadmill > 0 ? treadmillBusy : treadmillEmpty,
    },
    {
      name: "Ellipticals 6",
      type: "image",
      width: 130,
      xAxis: 780,
      yAxis: 160,
      body: totalOccupiedEllipticals > 5 ? ellipticalsBusy : ellipticalsEmpty,
    },
    {
      name: "Ellipticals 5",
      type: "image",
      width: 130,
      xAxis: 830,
      yAxis: 190,
      body: totalOccupiedEllipticals > 4 ? ellipticalsBusy : ellipticalsEmpty,
    },
    {
      name: "Ellipticals 4",
      type: "image",
      width: 130,
      xAxis: 880,
      yAxis: 220,
      body: totalOccupiedEllipticals > 3 ? ellipticalsBusy : ellipticalsEmpty,
    },
    {
      name: "Ellipticals 3",
      type: "image",
      width: 130,
      xAxis: 930,
      yAxis: 250,
      body: totalOccupiedEllipticals > 2 ? ellipticalsBusy : ellipticalsEmpty,
    },
    {
      name: "Ellipticals 2",
      type: "image",
      width: 130,
      xAxis: 980,
      yAxis: 280,
      body: totalOccupiedEllipticals > 1 ? ellipticalsBusy : ellipticalsEmpty,
    },
    {
      name: "Ellipticals 1",
      type: "image",
      width: 130,
      xAxis: 1040,
      yAxis: 310,
      body: totalOccupiedEllipticals > 0 ? ellipticalsBusy : ellipticalsEmpty,
    },
  ];

  return (
    <>
      <div className={classes.container}>
        <OccupancyCardRenderer
          heading={"Equipment Room Occupancy"}
          fieldList={fieldsList}
        />
      </div>

      <Grid className={classes.container} container spacing={2}>
        <Grid item xs={12} lg={8}>
          <Paper className={classes.paperContainer} elevation={7}>
            <SvgContainer
              title="Pool Area"
              mappingArray={equipmentRoomMap}
              image={equipmentRoomImage}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} lg={4}>
          <Paper className={classes.paperContainer} elevation={7}>
            <div className={classes.chartContainer}>
              <MafcEquipmentPopularTimes
                options={equipmentOptions}
                startDate={startDate}
                endDate={endDate}
              />
            </div>
          </Paper>
        </Grid>
      </Grid>
      <Grid className={classes.container} container spacing={2}>
        <Grid item xs={12}>
          <Paper elevation={7}>
            <MafcEquipmentWeeklySummary
              options={equipmentOptions}
              startDate={startDate}
              endDate={endDate}
            />
          </Paper>
        </Grid>
      </Grid>
      <Grid className={classes.container} container spacing={2}>
        {fieldsList.map((field, index) => (
          <Grid key={index} item xs={12} sm={6} md={3}>
            <OccupancyCard fieldsList={field} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default MafcEquipmentRoom;
